/* eslint-disable no-restricted-globals */
import moment from 'moment';
import { has } from 'lodash';
import {
  CANCEL_AND_REFUND,
  CANCEL_REASON,
  CHANGE_STATUS,
  DISABLE_REFILL,
  EDIT_LINK,
  MASS_CANCEL_AND_REFUND,
  MASS_CHANGE_STATUS,
  MASS_REQUEST_CANCEL,
  MASS_REQUEST_REFILL,
  MASS_RESEND,
  MASS_UPDATE_FROM_PROVIDER,
  ORDER_DETAILS,
  ORDER_DETAILS_SUPER_ADMIN,
  REQUEST_CANCEL,
  REQUEST_REFILL,
  RESEND_ORDER,
  SET_PARTIAL,
  SET_REMAINS,
  SET_START_COUNT,
  UPDATE_FROM_PROVIDER,
  UPDATE_REMAINS,
} from './constants';

export const constants = {
  STATUS_PENDING: 0,
  STATUS_IN_PROGRESS: 1,
  STATUS_COMPLETED: 2,
  STATUS_PARTIAL: 3,
  STATUS_CANCELED: 4,
  STATUS_PROCESSING: 5,
  STATUS_FAIL: 6,
  STATUS_ERROR: 7,
  STATUS_AWAITING: 8,
};

export const generateTableHead = (access = {}) => [
  { value: 'All', type: 'all', access: true },
  { value: 'ID', type: 'id', access: true },
  { value: 'User', type: 'user', access: access.user_id },
  { value: 'Charge', type: 'charge', access: access.charge },
  { value: 'Link', type: 'link', access: true },
  { value: 'Start count', type: 'start_count', access: access.start_count },
  { value: 'Quantity', type: 'quantity', access: access.count },
  { value: 'Service', type: 'service', access: access.service_name },
  { value: 'Status', type: 'status', access: access.status },
  { value: 'Remains', type: 'remains', access: true },
  { value: 'Created', type: 'created', access: access.date },
  { value: 'Mode', type: 'mode', access: access.mode },
  { value: '', type: 'actions', access: true },
];

const checkDiffInCharge = (charge, origin) => {
  if (!origin || isNaN(origin) || !charge || isNaN(charge)) {
    return 'table__orders-charge';
  }

  if (Number(origin) > Number(charge)) {
    return 'table__orders-charge table__orders-charge--danger';
  }
};

export const makeTableRow = (item, access = {}) => [
  { value: '', type: 'checkbox', access: true },
  { value: item.id || '', type: 'user_id', access: true },
  { value: item.user || '', type: 'user', access: access.user_id },
  { value: String(item.charge) || '', type: 'charge', access: access.charge, className: checkDiffInCharge(item.charge, item.cost_formatted) },
  { value: item.link_url || '', type: 'link_url', access: true },
  { value: item.start_count, type: 'start_count', access: access.start_count },
  { value: item.count || '', type: 'count', access: access.count },
  { value: item.service_name || '', type: 'service', access: access.service_name },
  { value: item.status_name || '', type: 'status_name', access: access.status },
  { value: item.remains.toString().replace(/-/, '+') || '', type: 'remains', access: true },
  { value: item.created || '', type: 'date', access: access.date },
  { value: item.mode_name || '', type: 'mode_name', access: access.mode },
  { value: 'actions', type: 'actions', access: true },
];

// eslint-disable-next-line no-unused-vars
export const generateAccessMassDrop = (access = {}, t, query, actions = [], orders = []) => {
  const checkUpdateProvider = () => {
    if (Number(query.status) === constants.STATUS_COMPLETED || query.search_type === '1' || query.search_type === '4') {
      if (orders.some((item) => item?.access?.update_from_provider)) {
        return true;
      }

      return false;
    }

    return false;
  };

  const defaultMassActions = [
    Number(query.status) === constants.STATUS_FAIL
      && Number(query.status) !== constants.STATUS_CANCELED && {
      title: t('ActionsList.Resend'),
      id: MASS_RESEND,
      code: MASS_RESEND,
      defActionName: 'resend',
    },
    Number(query.status) !== constants.STATUS_COMPLETED
      && Number(query.status) !== constants.STATUS_CANCELED && {
      title: t('ActionsList.Change status'),
      id: MASS_CHANGE_STATUS,
      defActionName: 'change_status',
    },
    Number(query.status) !== constants.STATUS_CANCELED && {
      title: t('ActionsList.Cancel and refund'),
      id: MASS_CANCEL_AND_REFUND,
      code: MASS_CANCEL_AND_REFUND,
      defActionName: 'cancel',
    },
    checkUpdateProvider() && {
      title: t('ActionsList.Update from provider'),
      id: MASS_UPDATE_FROM_PROVIDER,
      defActionName: 'update_from_provider',
    },
    {
      title: t('ActionsList.Copy to clipboard'),
      id: 'MASS_COPY_TO_CLIPBOARD',
      defActionName: 'copy_to_clipboard',
    },
    (Number(query.status) === constants.STATUS_COMPLETED || !query.status)
      && Number(query.status) !== constants.STATUS_CANCELED && {
      title: t('ActionsList.Refill'),
      id: MASS_REQUEST_REFILL,
      code: MASS_REQUEST_REFILL,
      defActionName: 'refill',
    },
    {
      title: t('ActionsList.Request cancel'),
      id: MASS_REQUEST_CANCEL,
      defActionName: 'request_cancel',
    },
  ];

  const formatAccessMassActions = defaultMassActions?.filter(Boolean)?.filter((item) => {
    if (item.defActionName === 'copy_to_clipboard' || item.defActionName === 'request_cancel') {
      return item;
    }

    return Object.keys(access)
      .filter((item) => access[item])
      .includes(item.defActionName);
  });

  return formatAccessMassActions;
};

export const generateAccessItemDrop = (access = {}, config = {}, listAccess = {}, t) => {
  const defaultMassActions = [
    config?.view && {
      title: t('ActionsList.Details'),
      id: ORDER_DETAILS,
      defActionName: 'order_details',
    },
    (listAccess?.view_cancel_reason || listAccess.cancel_and_refund) && {
      title: t('ActionsList.Cancel reason'),
      id: CANCEL_REASON,
      defActionName: 'cancel_reason',
    },
    {
      title: t('ActionsList.Request cancel'),
      id: REQUEST_CANCEL,
      defActionName: 'cancel',
    },
    config?.refill && {
      title: t('ActionsList.Refill'),
      id: REQUEST_REFILL,
      defActionName: 'refill',
    },
    config?.refill && {
      title: t('ActionsList.Disable refill'),
      id: DISABLE_REFILL,
      defActionName: 'disable_refill',
    },
    config?.details && {
      title: t('ActionsList.Details for superadmin'),
      id: ORDER_DETAILS_SUPER_ADMIN,
      defActionName: 'superadmin_order_details',
    },
    config?.resend && {
      title: t('ActionsList.Resend order'),
      id: RESEND_ORDER,
      defActionName: 'resend_order',
    },
    config?.change_link && {
      title: t('ActionsList.Edit link'),
      id: EDIT_LINK,
      defActionName: 'edit',
    },
    config?.set_start_count && {
      title: t('ActionsList.Set start count'),
      id: SET_START_COUNT,
      defActionName: 'set_start_count',
    },
    config?.set_partial && {
      title: t('ActionsList.Set partial'),
      id: SET_PARTIAL,
      defActionName: 'set_partial',
    },
    config?.set_remains && {
      title: t('ActionsList.Set remains'),
      id: SET_REMAINS,
      defActionName: 'set_remains',
    },
    config?.update_remains && {
      title: t('ActionsList.Update remains'),
      id: UPDATE_REMAINS,
      defActionName: 'update_remains',
    },
    config?.change_status
      && Array.isArray(access?.change_status)
      && access?.change_status.length && {
      title: t('ActionsList.Change status'),
      id: CHANGE_STATUS,
      defActionName: 'change_status',
    },
    config?.cancel && {
      title: t('ActionsList.Cancel and refund'),
      id: CANCEL_AND_REFUND,
      defActionName: 'cancel_and_refund',
    },
    config?.update_from_provider && {
      title: t('ActionsList.Update from provider'),
      id: UPDATE_FROM_PROVIDER,
      defActionName: 'update_from_provider',
    },
  ];

  const formatAccessMassActions = defaultMassActions?.filter(Boolean).filter((item) => Object.keys(access)
    .filter((item) => access[item])
    .includes(item.defActionName));

  return formatAccessMassActions;
};

export const itemDropStatuses = (statuses, itemAccess = []) => {
  if (itemAccess === false || (Array.isArray(itemAccess) && !itemAccess.length)) {
    return [];
  }

  return itemAccess
    .map((item) => statuses.find((el) => el.code.trim() === item.trim()))
    .map((elem) => ({ id: elem.code.trim().toLowerCase(), title: elem.title }));
};

export const getDiffBetweenDates = (date1, date2) => {
  const a = moment(date1);
  const b = moment(date2);
  return Math.abs(a.diff(b, 'days'));
};

export const detectLoaderText = (queryString) => {
  let loaderText = '';

  if (has(queryString, 'period_code')) {
    if (queryString.period_code === 'last_year') {
      loaderText = 'Your data is loading. Please wait';
    }

    if (queryString.period_code === 'custom_range') {
      if (has(queryString, 'date_from') && has(queryString, 'date_to')) {
        const dateDiff = getDiffBetweenDates(queryString.date_to, queryString.date_from);
        loaderText = dateDiff > 90 ? 'Your data is loading. Please wait' : '';
      }
    }
  }

  return loaderText;
};

export const prepareTableString = (orders, values, access) => orders
  .filter((item) => values.includes(String(item.id)))
  .map(
    (item) => `${item.id}${access?.see_external_id ? `\t${item.external_id}` : ''}${access?.user_id ? `\t${item.user}` : ''}${
          access?.charge ? `\t${String(item.charge || '').replace('$', '')}` : ''
        }${access?.see_cost ? `\t${item.cost_formatted || ''}` : ''}\t${item.link}${access.start_count ? `\t${item.start_count || ''}` : ''}${
          access?.count ? `\t${item.count}` : ''
        }${access?.service_name ? `\t${item.service_id}` : ''}${access?.service_name ? `\t${item.service_name}` : ''}${
          access?.status ? `\t${item.status_name}` : ''
        }\t${item.remains.toString().replace(/-/, '+')}${access?.date ? `\t${item.created}` : ''}${access?.mode ? `\t${item.mode_name}` : ''}${
          access?.showProvider ? `\t${item.provider}` : ''
        }`,
  );

/**
 * @name checkStartCountIcon
 * @param count {Number | String} - Проверка счетчика для start_count
 * @param message {String | null} - Сообщения для тултипа
 */
export const checkStartCountIcon = (count, message) => {
  if (count && Number(count) === -1 && message) {
    return { value: '', tooltip: true, tooltipText: message, icon: 'far fa-clock' };
  }

  if (count && Number(count) === -2 && message) {
    return { value: '', tooltip: true, tooltipText: message, icon: 'far fa-times-circle' };
  }

  if (count && Number(count) === -3 && message) {
    return { value: '', tooltip: true, tooltipText: message, icon: 'far fa-minus-circle' };
  }

  return { value: count, tooltip: false };
};

export const countDecimalMax = (values) => {
  let maxCount = 0;
  values?.forEach((value) => {
    if (Math.floor(value) === value) {
      maxCount = Math.max(maxCount, 0);
    } else {
      maxCount = Math.max(maxCount, String(value)?.split('.')?.[1]?.length || 0);
    }
  });
  return maxCount;
};
